import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { EyeIcon, ModalControl, ModalProvider } from '@paygreen/paygreen-ui';
import OffsetsDetailsModal from './offsetsDetails/OffsetsDetailsModal';

const ActionsCell = ({ t, idFootprint, value }) => {
    // details button is not available for empty footprints
    const detailsIconProps = (condition) => {
        return {
            iconSize: 'sm',
            colorPallet: 'theme',
            hasBackground: true,
            hasHover: condition,
            htmlTag: condition ? 'button' : 'span',
            style: condition
                ? null
                : {
                      filter: 'grayscale(1)',
                  },
        };
    };

    const SeeDetailsIcon = (props) => {
        // to capture and prevent mousedown event to open DaTableRow when clicking on buttons (DaTableRow open/close on mousedown) if button is disabled
        const handleOnMouseDown = (e) => {
            if (e.stopPropagation && !Number(value)) {
                e.stopPropagation();
            }
            !!Number(value) && props.setOpen(true);
        };

        return (
            <EyeIcon
                title={
                    Number(value)
                        ? t('offsets.details.titleDetails')
                        : t('offsets.details.titleNoDetails')
                }
                onMouseDown={(e) => handleOnMouseDown(e)}
                {...detailsIconProps(!!Number(value))}
            />
        );
    };

    return (
        <ModalProvider>
            <ModalControl>
                <SeeDetailsIcon />

                <OffsetsDetailsModal idFootprint={idFootprint} />
            </ModalControl>
        </ModalProvider>
    );
};

ActionsCell.propTypes = {
    idFootprint: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

ActionsCell.defaultProps = {
    value: 0,
};

export default withTranslation('common')(ActionsCell);
